import axios from "axios";

// Get the API base URL from environment variables
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

// Create Axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  withCredentials: true, // Ensures cookies/auth headers are sent with cross-origin requests
  headers: {
    "Content-Type": "application/json",
  },
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Server responded with error status
      console.error("API Error:", error.response.status, error.response.data);
    } else if (error.request) {
      // Request made but no response
      console.error("No response from server:", error.request);
    } else {
      console.error("Request Error:", error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
